import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Maths } from '../_app/cuchillo/utils/Maths';
import { Ease } from '../_app/cuchillo/utils/Ease';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';

export class ScrollItem__BlockLanding extends ScrollItem__BlockDefault {
    figure;

    _calls = {
        loop: () => this.loop()
    }

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.figure = GetBy.selector('figure', __link)[0];

        const title = GetBy.selector('.__title', this.item);
        if (title.length > 0) {
            new SplitText(title, {
                type: 'lines',
                linesClass: 'line-parent'
            });
            this.title = new SplitText(title, {
                type: 'words'
            }).words;
            gsap.set(this.title, { y: '100%' });
        }

        const claim = GetBy.selector('h1', this.item);
        if (claim.length > 0) {
            // new SplitText(claim, {
            //     type: 'lines',
            //     linesClass: 'line-parent'
            // });
            this.claim = new SplitText(claim, {
                type: 'words'
            }).words;
            gsap.set(this.claim, { y: '100%' });
        }

        this.loop();
    }

    showFunction() {
        super.showFunction();
        gsap.ticker.add(this._calls.loop);

        let delay = 0;

        if (this.title.length > 0) {
            for (let i = 0; i < this.title.length; i++) {
                const title = this.title[i];
                gsap.to(title, {
                    y: 0,
                    delay: delay + i * .2,
                    duration: 1.6,
                    ease: Ease.EASE_CUCHILLO_IN_OUT
                });
            }
        }

        if (this.claim.length > 0) {
            for (let i = 0; i < this.claim.length; i++) {
                const title = this.claim[i];
                gsap.to(title, {
                    y: 0,
                    delay: delay + i * .2,
                    duration: 1.6,
                    ease: Ease.EASE_CUCHILLO_IN_OUT
                });
            }
        }
    }

    hideFunction() {
        super.hideFunction();
        gsap.ticker.remove(this._calls.loop);
    }

    loop() {
        const y = Maths.clamp(Maths.map(this.progress, 0.5, 1, 0, 45), 0, 100);
        const scale = Math.max(Maths.map(this.progress, 0.5, 1, 1, 1.4), 1);
        const opacity = Maths.clamp(Maths.map(this.progress, 0.5, 1, 1, 0), 0, 1);

        gsap.set(this.figure, { y: `${y}%`, opacity, scale });
    }
}

Scroll._registerClass('BlockLanding', ScrollItem__BlockLanding);
